import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { RequestService } from './requestService';

@Injectable()
export class BillingService {
  constructor(
    private http: HttpClient,
    private _requestService: RequestService
  ) {}

  fetchBillingInfo(unitID) {
    return this._requestService.request<any>(
      'GET',
      environment.apiUrl + `billing/customers/${unitID}/`
    );
  }

  fetchInvoices(unitID) {
    return this._requestService.request<any>(
      'GET',
      environment.apiUrl + `billing/customers/${unitID}/invoices/`
    );
  }

  fetchSubscriptions(unitID) {
    return this._requestService.request<any>(
      'GET',
      environment.apiUrl + `billing/customers/${unitID}/subscriptions/`
    );
  }

  fetchMojobBillingPlans() {
    return this._requestService.request<any>(
      'GET',
      environment.apiUrl + `billing/mojob-plans/`
    );
  }

  activateSubscription(unitID, body) {
    return this._requestService.request<any>(
      'POST',
      environment.apiUrl + `billing/customers/${unitID}/subscribe/`,
      null,
      body
    );
  }

  updateBillingInfo(unitID, body) {
    return this._requestService.request<any>(
      'PUT',
      environment.apiUrl + `billing/customers/${unitID}/`,
      '',
      body
    );
  }

  checkPaymentStatus(unitID) {
    return this._requestService.request<any>(
      'GET',
      environment.apiUrl + `billing/billing-account/${unitID}/`
    );
  }
}
